<template>
  <div>
    <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="所属组织" prop="orgid">
            <el-cascader v-fixZoom style="width: 100%" :options="orgOptions"
                         v-model="addEditForm.orgid" :filterable="true" placeholder="请选择"
                         :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                         ref="orgOptions">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权益包名称" prop="name">
            <el-input v-model="addEditForm.name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务套餐" prop="alias">
            <el-input v-model="addEditForm.alias" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用天数/天" prop="valid_days">
            <el-input v-model="addEditForm.valid_days" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="套餐价格/元" prop="price">
            <el-input v-model="addEditForm.price" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="享受价值/元" prop="market_value">
            <el-input v-model="addEditForm.market_value" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-col :span="16">
            <el-form-item label="备注" prop="">
              <el-input v-model="addEditForm.remark" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="套餐描述" prop="">
              <el-input type="textarea" v-model="addEditForm.description" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div style="width: 90px;margin: auto">
              <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
                         :on-exceed="handleExceed" :before-upload="beforeUpload" :on-change="getFile"
                         list-type="picture" :file-list="fileList" :on-preview="handlePictureCardPreview">
                <img v-if="addEditForm.fileurl" :src="addEditForm.fileurl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div style="text-align: center">上传图片</div>
          </el-col>
        </el-col>
        <el-col :span="24">
          <el-col :span="23">
            <el-form-item label="套餐类型" prop="">
              <el-radio-group v-model="addEditForm.good_type" @change="changeGoodType">
                <el-radio :label="1">融合服务套餐</el-radio>
                <el-radio :label="2">单服务套餐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="addEditForm.good_type === 2">
            <el-form-item label="服务类型" prop="good_category">
              <el-radio-group v-model="addEditForm.good_category">
                <el-radio label="应急救援">应急救援</el-radio>
                <el-radio label="陪诊就医">陪诊就医</el-radio>
                <el-radio label="生活代办">生活代办</el-radio>
                <el-radio label="各类咨询">各类咨询</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="addEditForm.good_type === 2">
            <el-form-item label="服务内容" prop="supplier_service_id">
              <el-cascader v-fixZoom class="my-form-inpt" style="width: 100%" :options="typeTree" v-model="addEditForm.supplier_service_id" :filterable="true" placeholder="请选择"
                           :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'isService'}" ref="typeOptions">
                <template #default="{data}">
                  <span v-if="data.is_service !== 1" style="font-style: italic;color: #999999">{{ data.typename}}</span><strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="套餐内容" prop="" v-if="addEditForm.good_type === 1 || (goodArr.length === 0 && addEditForm.good_type === 2)">
              <div v-if="addEditForm.good_type === 1" style="margin-top: 7px" class="btn-add" @click="addGood()">+ 添加</div>
              <div v-if="goodArr.length === 0 && addEditForm.good_type === 2" style="margin-top: 7px" class="btn-add" @click="addGood()">+ 添加</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
          <div v-if="goodArr.length > 0" style="margin-left: 30px;background: #EBF2FA;padding: 10px;box-sizing: border-box;border-radius: 10px;color: #1A1A1A;margin-top: 10px;letter-spacing: 1px">
            <div v-for="(item, index) in goodArr" :key="index">
              <div style="min-height: 40px;display: flex;border-bottom: 1px solid #cbcbcb">
                <div style="flex: 1" v-if="item.type === 'coupon'">
                  <span>{{item.category}}{{item.face_value}}元{{item.title}}</span>
                </div>
                <div style="flex: 1" v-if="item.type === 'device'">
                  <span>{{item.title}}价值{{item.estimated_value}}元</span>
                </div>
                <div style="flex: 1" v-if="item.type === 'service'">
                  <div style="height: 24px"><span>{{item.title}}价值{{item.value}}元</span></div>
                  <div style="height: 40px;color: #7e7d7d"><span>{{item.note}}</span></div>
                </div>
                <div><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delGood(index)"></i></div>
              </div>
            </div>
          </div>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <div style="height: 60px;margin-top: 20px">
      <el-row style="margin: 0 40px">
        <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
        <el-col :span="12"><div class="send-btn" @click="commitInfo('addEditForm')"><span>确定</span></div></el-col>
      </el-row>
    </div>
    <el-dialog width="500px" title="添加内容" :visible.sync="goodSHow"
      v-if="goodSHow" append-to-body>
      <el-form style="margin-right: 30px" :model="goodForm" :rules="goodRules" ref="goodForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="类型" prop="type">
          <el-select v-fixZoom v-model="goodForm.type" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in typeOptions" :key="item.type" :label="item.label" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="goodForm.type === 'coupon'">
          <el-form-item label="机构名称" prop="category">
            <el-input v-model="goodForm.category" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="优惠券名称" prop="title">
            <el-input v-model="goodForm.title" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="价格/元" prop="face_value">
            <el-input type="number" v-model="goodForm.face_value" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div v-if="goodForm.type === 'device'">
          <el-form-item label="设备名称" prop="title">
            <el-input v-model="goodForm.title" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="价格/元" prop="estimated_value">
            <el-input type="number" v-model="goodForm.estimated_value" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <div v-if="goodForm.type === 'service'">
          <el-form-item label="服务名称" prop="title">
            <el-input v-model="goodForm.title" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="价格/元" prop="value">
            <el-input type="number" v-model="goodForm.value" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="">
            <el-input v-model="goodForm.note" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <el-row style="margin: 0 40px">
          <el-col :span="12"><div class="cancel-btn" @click="closeGoodOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="addGoodForm('goodForm')"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
      <div style="text-align: center">
        <img style="max-width: 100%" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {minigoodsAdd, minigoodsUpdate} from '../../../api/project'
import {uploadfile} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditProject',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      typeTree: [], // 服务内容
      orgOptions: [],
      typeOptions: [
        {type: 'coupon', label: '优惠券'},
        {type: 'device', label: '设备'},
        {type: 'service', label: '服务'}
      ],
      goodArr: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      addEditForm: {
        supplier_service_id: '',
        orgid: '',
        name: '',
        alias: '',
        price: '',
        currency: 'CNY',
        valid_days: '',
        market_value: '',
        description: '',
        includes: [],
        remarks: [],
        version: 1,
        good_type: 1,
        good_category: '陪诊就医',

        remark: '',
        filename: '',
        fileurl: ''
      },
      addEditRules: {
        supplier_service_id: [{ required: true, message: '请选择', trigger: 'change' }],
        good_category: [{ required: true, message: '请选择', trigger: 'change' }],
        orgid: [{ required: true, message: '请选择', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        alias: [{ required: true, message: '请输入', trigger: 'blur' }],
        price: [{ required: true, message: '请输入', trigger: 'blur' }],
        valid_days: [{ required: true, message: '请输入', trigger: 'blur' }],
        market_value: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      goodSHow: false,
      goodForm: {
        type: '',
        category: '',
        title: '',
        face_value: '',
        unit: '分',
        estimated_value: '',
        value: '',
        note: ''
      },
      goodRules: {
        type: [{ required: true, message: '请选择', trigger: 'change' }],
        category: [{ required: true, message: '请输入', trigger: 'blur' }],
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        face_value: [{ required: true, message: '请输入', trigger: 'blur' }],
        estimated_value: [{ required: true, message: '请输入', trigger: 'blur' }],
        value: [{ required: true, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  created () {
    console.log(this.addEditRow.row)
    this.getTypeTree()
    this.getTreeData()
    this.getStartData()
  },
  methods: {
    getTypeTree () {
      let lastLevel = 100
      const arr = this.clone(this.addEditRow.types)
      console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        arr[i].isService = false
        if (arr[i].is_service === 0) {
          arr[i].isService = true
        }
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.typeTree.push(arr[i])
        }
      }
      for (let i = 0; i < this.typeTree.length; i++) {
        const child = this.arrayToNode1(arr, this.typeTree[i].id)
        if (child.length !== 0) {
          this.typeTree[i].child = child
        }
      }
      console.log(this.typeTree)
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.upid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getStartData () {
      if (!this.addEditRow.isAdd) {
        let goodArr = []
        let good = ''
        let arr = []
        if (this.addEditRow.row.showGood) {
          good = this.clone(this.addEditRow.row.showGood)
          arr = good.includes
        }
        for (let i = 0; i < arr.length; i++) {
          let obj = arr[i]
          if (obj.type === 'coupon') {
            obj.face_value = arr[i].face_value / 100
          } else if (obj.type === 'device') {
            obj.estimated_value = arr[i].estimated_value / 100
          } else if (obj.type === 'service') {
            obj.value = arr[i].value / 100
          }
          goodArr.push(obj)
        }
        console.log(good)
        this.goodArr = goodArr
        this.addEditForm.good_type = good.good_type
        this.addEditForm.good_category = good.good_category
        this.addEditForm.orgid = this.addEditRow.row.orgid
        this.addEditForm.supplier_service_id = this.addEditRow.row.supplier_service_id
        this.addEditForm.name = good.name
        this.addEditForm.alias = good.alias
        this.addEditForm.price = good.price / 100
        this.addEditForm.currency = good.currency
        this.addEditForm.valid_days = good.valid_days
        this.addEditForm.market_value = good.market_value / 100
        this.addEditForm.description = good.description
        this.addEditForm.remark = good.remarks.length > 0 ? good.remarks[0] : ''
        this.addEditForm.version = good.version
        this.addEditForm.filename = good.filename
        let url = (window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host) + '/api/v1/web/staticfile/file/'
        if (good.filename && good.filename !== '') {
          this.addEditForm.fileurl = url + good.filename
        }
      }
    },
    // 所属组织
    getTreeData () {
      // 所属组织
      let lastLevel = 100
      let arr = this.addEditRow.orgData
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.orgOptions.push(arr[i])
        }
      }
      for (let i = 0; i < this.orgOptions.length; i++) {
        const child = this.arrayToNode(arr, this.orgOptions[i].id)
        if (child.length !== 0) {
          this.orgOptions[i].child = child
        }
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    changeGoodType () {
      // if (this.addEditForm.good_type === 2) {
      //   this.goodArr = []
      // }
    },
    addGood () {
      this.goodForm = {
        orgid: '',
        type: '',
        category: '',
        title: '',
        face_value: '',
        unit: '分',
        estimated_value: '',
        value: '',
        note: ''
      }
      if (this.addEditForm.good_type === 1) {
        this.typeOptions = [
          {type: 'coupon', label: '优惠券'},
          {type: 'device', label: '设备'},
          {type: 'service', label: '服务'}
        ]
      } else {
        this.typeOptions = [
          {type: 'service', label: '服务'}
        ]
        this.goodForm.type = 'service'
      }
      this.goodSHow = true
    },
    delGood (index) {
      this.goodArr.splice(index, 1)
    },
    closeGoodOpen () {
      this.goodSHow = false
    },
    addGoodForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.goodArr.push(this.goodForm)
          this.goodSHow = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 上传图片
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '套餐照片',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传', type: 'success' })
        this.addEditForm.fileurl = res.data.fileurl
        this.addEditForm.filename = res.data.filename
      }).catch(() => {
        this.$message.closeAll()
        this.addEditForm.fileurl = ''
        this.addEditForm.filename = ''
        this.$message({ message: '上传失败', type: 'error' })
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 查看图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    closeOpen () {
      this.$emit('change', false)
    },
    commitInfo (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.goodArr.length === 0) {
            this.$message.warning('请添加套餐内容。')
            return
          }
          let includes = []
          for (let i = 0; i < this.goodArr.length; i++) {
            let item = this.goodArr[i]
            let obj = {
              type: item.type,
              category: item.category,
              title: item.title,
              unit: item.unit,
              note: item.note,
              item_id: i + 1
            }
            if (item.type === 'coupon') {
              obj.face_value = item.face_value * 100
            }
            if (item.type === 'device') {
              obj.estimated_value = item.estimated_value * 100
            }
            if (item.type === 'service') {
              obj.value = item.value * 100
            }
            includes.push(obj)
          }
          let good = {
            good_category: this.addEditForm.good_type === 2 ? this.addEditForm.good_category : '',
            good_type: this.addEditForm.good_type,
            filename: this.addEditForm.filename,
            name: this.addEditForm.name,
            alias: this.addEditForm.alias,
            price: parseFloat(this.addEditForm.price) * 100,
            currency: this.addEditForm.currency,
            valid_days: this.addEditForm.valid_days,
            market_value: parseFloat(this.addEditForm.market_value) * 100,
            description: this.addEditForm.description,
            includes: includes,
            remarks: [this.addEditForm.remark]
          }
          let data = {
            good_category: this.addEditForm.good_type === 2 ? this.addEditForm.good_category : '',
            good_type: this.addEditForm.good_type,
            orgid: this.addEditForm.orgid,
            good_name: this.addEditForm.name,
            supplier_service_id: this.addEditForm.good_type === 2 ? this.addEditForm.supplier_service_id : 0,
            good: JSON.stringify(good)
          }
          console.log(data)
          if (this.addEditRow.isAdd) {
            minigoodsAdd(data).then(res => {
              this.$message.success('添加成功')
              this.$emit('changeData')
              this.$emit('change', false)
            })
          } else {
            data.id = this.addEditRow.row.id
            minigoodsUpdate(data).then(res => {
              this.$message.success('编辑成功')
              this.$emit('changeData')
              this.$emit('change', false)
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.btn-add{
  width: 58px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #3D83F3;
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3D83F3;
}
.table-type{
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}
.table-type th{
  text-align: left;
  padding-left: 10px;
  box-sizing: border-box;
  height: 30px;
  background: #EBF2FA;
  color: #3D83F3;
  font-size: 14px;
}
.table-type td{
  padding: 5px;
  box-sizing: border-box;
  background: #F3F7FC;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
}
.input{
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #b3cbee;
  outline: none;
  height: 30px;
  font-size: 14px;
  background: none;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/businessWeChat/businessComponents/addEditProject.vue